import React from 'react';
import T from 'prop-types';

import MetricList, { metricListPropTypes, metricsToOptions } from '../MetricList';

const buildMetrics = () => ({
  dau: {
    dau: 'Market Share',
    dau_cumulative_change: 'Cumulative Share',
    dau_over_change: 'Change in Market Share',
  },
  downloads: {
    downloads: 'Market Share',
    downloads_cumulative_change: 'Cumulative Share',
    downloads_over_change: 'Change in Market Share',
  },
});

export const marketShareMetrics = {
  ...buildMetrics().dau,
  ...buildMetrics().downloads,
};

const buildMarketShareMetricsOptions = (decorateOption) => {
  const metrics = buildMetrics();

  return [
    { label: 'DAU', value: 'header' },
    ...metricsToOptions(metrics.dau).map((option) => {
      const decoratedOption = decorateOption ? decorateOption(option) : option;

      return {
        ...decoratedOption,
        buttonLabel: `${decoratedOption.label} — DAU`,
      };
    }),
    { value: 'divider' },
    { label: 'Downloads', value: 'header' },
    ...metricsToOptions(metrics.downloads).map((option) => {
      const decoratedOption = decorateOption ? decorateOption(option) : option;

      return {
        ...decoratedOption,
        buttonLabel: `${decoratedOption.label} — Downloads`,
      };
    }),
  ];
};

export const MarketShareDropdown = ({ selected, disabled, decorateOption, onChange }) => {
  const marketShareMetricsOptions = buildMarketShareMetricsOptions(decorateOption);

  return (
    <MetricList
      selected={selected}
      disabled={disabled}
      options={marketShareMetricsOptions}
      menuWidth={238}
      onChange={onChange}
    />
  );
};

MarketShareDropdown.propTypes = {
  ...metricListPropTypes,
  decorateOption: T.func, // optional function to decorate each option
};
